import { put, call, takeLatest } from "redux-saga/effects";

import * as Actions from "redux/actions/User";
import * as Types from "redux/constants/User";

import UserService from "services/UserService";

export function* fetchProfileEffect({ payload }) {
  try {
    const { data: profile } = yield call(UserService.fetchProfile, payload);
    yield put(
      Actions.fetchProfileOk({
        ...profile,
        worksAtCompany: profile.company !== null,
      })
    );
  } catch (err) {
    const response = err.response;
    yield put(
      Actions.fetchProfileFailed({
        status: response.status,
        message: response.data.message,
        errors: [],
      })
    );
  }
}

export default function* rootSaga() {
  yield takeLatest(Types.FETCH_PROFILE, fetchProfileEffect);
}
